<template>
    <div class="not_found">
        <h1>404</h1>
        <h2>page not fund</h2>
        <router-link :to="{name: 'Index'}">
            GO TO HOME
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
    components: {},
    data: function() {
        return {

        }
    }
}
</script>

<style>
.not_found {
    width: 100%;
    padding-top: 10vh;
}
.not_found h1{
    text-align: center;
    font-weight: bold;
    font-size: 70px;
}
.not_found h2{
    text-align: center;
    color: red;
}
.not_found a{
    margin-top: 20px;
    display: block;
    text-align: center;
    text-decoration:none;
    color: red;
}
</style>